import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return {
    id: data?.id ?? '',
    name: data?.username ?? '',
    group: `${data?.group?.id ?? ''}`,
    type: data?.type ?? '',
    accessConfig: JSON.stringify(data?.group?.accessConfig ?? ''),
    status: data?.isActive ? 'Active' : 'Inactive',
  }
}

const getUserWithId = (id: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: `${getUrl(APIEndPoints.getMenuInfo)}/${id}`,
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getUserWithId }
